import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class AdvancedContentToggle extends UcoastEl {
	static htmlSelector = 'advanced-content-toggle'
  static selectors = {
    contentToggle: '[data-uc-advanced-content-toggle-toggle-item]',
    disclosureItem: '[data-uc-advanced-content-toggle-disclosure-item]',
    detailsItem: '[data-uc-advanced-content-toggle-details-item]',
  };
	contentToggles: NodeListOf<HTMLElement>
	disclosureItems: NodeListOf<HTMLElement>
	detailsItems: NodeListOf<HTMLDetailsElement>
	currentIndex: number = 0
	openFirstItem: boolean = true
	anchorNavs?: NodeListOf<HTMLButtonElement>
	anchorPoints?: NodeListOf<HTMLElement>
	constructor() {
		super()
		this.contentToggles = q.rl(AdvancedContentToggle.selectors.contentToggle, this)
		this.disclosureItems = q.rl(AdvancedContentToggle.selectors.disclosureItem, this)
		this.detailsItems = q.rl(AdvancedContentToggle.selectors.detailsItem, this)
		if (this.hasAttribute('data-uc-advanced-content-toggle-default-closed')) {
			this.openFirstItem = false
			this.currentIndex = -1
		} else {
      this.openFirstItem = true;
      this.currentIndex = AdvancedContentToggle.getIndexFromContentToggle(q.os(AdvancedContentToggle.selectors.contentToggle, this));
    }
		this.anchorNavs = q.ol('[data-uc-advanced-content-toggle-anchor-nav]', this)
		this.anchorPoints = q.ol('[data-uc-advanced-content-toggle-anchor-point]', this)
		this.anchorNavs?.forEach((nav) => {
			const anchorHandle = q.ra(nav, 'data-uc-advanced-content-toggle-anchor-nav')
			nav.addEventListener('click', (e: Event) => {
				e.preventDefault()
				this.goToAnchor(anchorHandle)
			})
		})
	}

	goToAnchor(handle: string) {
        this.anchorNavs?.forEach(nav => {
            const navHandle = q.ra(nav, 'data-uc-advanced-content-toggle-anchor-nav')
            if (navHandle === handle) {
                nav.classList.add('underline-always')
                nav.classList.remove('underline-on-hover')
            } else {
                nav.classList.remove('underline-always')
                nav.classList.add('underline-on-hover')
            }
        })
        const allHeaderSections = q.ol('.shopify-section-group-header-group')
        let headerDistance = 0
        allHeaderSections?.forEach(section => {
            headerDistance += section.offsetHeight
        })
        const anchorDistanceFromTop = q.rs(`[data-uc-advanced-content-toggle-anchor-point="${handle}"]`, this).getBoundingClientRect().top + window.scrollY
        const combinedDistance = anchorDistanceFromTop - headerDistance
        window.scrollTo({
            top: combinedDistance,
            behavior: "smooth"
        })

    }

	override connectedCallback() {
		super.connectedCallback()
		if (this.openFirstItem) {
      setTimeout(() => {
        this.open(true)
      }, 100);
		}

		this.contentToggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault()
				const index = parseInt(q.ra(toggle, 'data-uc-advanced-content-toggle-toggle-item'))
				if (index === this.currentIndex) {
					this.setCurrentIndex(-1)
				} else {
					this.setCurrentIndex(index)
				}

				this.open()
			})
		})
	}
	setCurrentIndex(index: number) {
		this.currentIndex = index
	}
  static getIndexFromContentToggle(toggle?: HTMLElement) {
    return parseInt(toggle?.dataset.ucAdvancedContentToggleToggleItem ?? '0');
  }
	open(immediate = false) {
		for (let i = 0; i < this.disclosureItems.length; i++) {
			const contentToggle = this.contentToggles[i]
      const index = AdvancedContentToggle.getIndexFromContentToggle(contentToggle);
			const disclosureItem = this.disclosureItems[i]
			const detailsItem = this.detailsItems[i]
			if (index === this.currentIndex) {
				disclosureItem.style.maxHeight = '0px'
				detailsItem.setAttribute('open', '')
				detailsItem.classList.add('active')
				window.setTimeout(() => {
					disclosureItem.style.maxHeight = immediate ? 'fit-content' : `${disclosureItem.scrollHeight}px`;
				}, 1)
				contentToggle.classList.add('active')
			} else {
				disclosureItem.style.maxHeight = '0px'
				contentToggle.classList.remove('active')
				detailsItem.classList.remove('active')
				window.setTimeout(() => {
					detailsItem.removeAttribute('open')
				}, 301)
			}
		}
	}
}
